$(document).on('turbo:load', function() {
    $('#search_apprentice').autocomplete({
        source: $('#search_apprentice').data('autocomplete-source')
    })
});